import config from "./config";
import api from './api'
import formatter from './formatter'
import { profile } from "../stores/storages/ProfileStorage";

const FileService = {
  uploadFile: async (url, file, type) => {
    const { username: msisdn, token } = profile.authAPI;
    const data = new FormData();
    data.append("msisdn", msisdn);
    data.append("type", type);
    data.append("token", token);
    data.append("uploadfile", file);

    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      fullPath: true,
      decrypt: false,
    };

    const res = await api.request({
      method: "post",
      path: url,
      host: config.host,
      data,
      options,
    });
    return res;
  },

  uploadGroupAvatar: async ( groupId, file ) => {
    try {
      const { token, username: msisdn } = profile.authAPI;
      const timestamp = new Date().getTime();
      const security = formatter.encrypt(
        `${msisdn}${groupId}${token}${timestamp}`
      );
      const data = new FormData();
      data.append("msisdn", msisdn);
      data.append("groupid", groupId);
      data.append("timestamp", timestamp);
      data.append("security", security);
      data.append("uploadfile", file);
      data.append("resource", "desktop");

      const options = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        fullPath: false,
        decrypt: false,
      };
      return api.request({
        method: config.endpoints.group.uploadAvatar.method,
        path: config.endpoints.group.uploadAvatar.path,
        host: config.host,
        data,
        options,
      })
    } catch (err) {
      return Promise.reject(err);
    }
  },

  uploadLog: async (url, file) => {
    const { username: msisdn } = profile.authAPI;
    const data = new FormData();
    data.append("msisdn", msisdn);
    data.append("logtype", 'mocha_web');
    data.append("uploadfile", file);

    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      fullPath: true,
      decrypt: false,
    };

    const res = await api.request({
      method: "post",
      path: url,
      host: config.host,
      data,
      options,
    });
    return res;
  },
};

export default FileService;